import { render, staticRenderFns } from "./CombinationsEditPopup.vue?vue&type=template&id=e1a37ff4&scoped=true"
import script from "./CombinationsEditPopup.vue?vue&type=script&lang=ts"
export * from "./CombinationsEditPopup.vue?vue&type=script&lang=ts"
import style0 from "./CombinationsEditPopup.vue?vue&type=style&index=0&id=e1a37ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a37ff4",
  null
  
)

export default component.exports